import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=1dc21441&scoped=true&"
import script from "./productList.vue?vue&type=script&lang=babel&"
export * from "./productList.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc21441",
  null
  
)

export default component.exports